import { MapPinIcon, SearchIcon } from "lucide-react"
import { Link } from "react-router"

import Logo from "@/assets/KC_logo_2008.webp"
import { Button } from "@/components/ui/shadcn/button"

import "./mobile-store-shell.css"

type MobileStoreHeaderProps = {
  city: string
  onCityClick: () => void
  onSearchClick: () => void
}

const MobileStoreHeader = ({ city, onCityClick, onSearchClick }: MobileStoreHeaderProps) => (
  <>
    <div className="mobile-store-city-bar">
      <Button
        type="button"
        variant="inverse"
        data-motion="static"
        className="min-h-11 min-w-0 justify-start px-0"
        onClick={onCityClick}
      >
        <MapPinIcon data-icon="inline-start" />
        <span className="truncate">{city || "Выберите город"}</span>
      </Button>
    </div>

    <header className="mobile-store-header">
      <Link to="/" aria-label="КЦ Авто — главная" className="mobile-store-logo-link">
        <img src={Logo} alt="КЦ Авто" className="mobile-store-logo" />
      </Link>
      <Button
        type="button"
        variant="ghost"
        size="icon-lg"
        aria-label="Открыть поиск"
        onClick={onSearchClick}
      >
        <SearchIcon />
      </Button>
    </header>
  </>
)

export default MobileStoreHeader
